import React from 'react'
import { NavLink } from 'react-router-dom'
import { Home, AlertTriangle, Wrench, Settings, BarChart3 } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

interface MobileNavigationProps {
  currentPath: string
  alertCount?: number
  workOrderCount?: number
}

interface NavItem {
  path: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  badge?: number
}

export default function MobileNavigation({ 
  currentPath, 
  alertCount = 0, 
  workOrderCount = 0 
}: MobileNavigationProps) {
  const navItems: NavItem[] = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: Home,
    },
    {
      path: '/alerts',
      label: 'Alerts',
      icon: AlertTriangle,
      badge: alertCount,
    },
    {
      path: '/work-orders',
      label: 'Work Orders',
      icon: Wrench,
      badge: workOrderCount,
    },
    {
      path: '/equipment',
      label: 'Equipment',
      icon: Settings,
    },
    {
      path: '/analytics',
      label: 'Analytics',
      icon: BarChart3,
    },
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-2 py-1 z-50 md:hidden">
      <div className="flex justify-around items-center">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = currentPath === item.path
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 py-2 px-3 relative touch-target ${
                isActive ? 'text-trust-blue' : 'text-gray-600'
              }`}
            >
              <div className="relative">
                <Icon className="w-5 h-5" />
                {item.badge && item.badge > 0 && (
                  <Badge className="absolute -top-2 -right-2 h-4 w-4 rounded-full p-0 text-xs bg-critical-red text-white flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </Badge>
                )}
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </NavLink>
          )
        })}
      </div>
    </div>
  )
}